module.exports = __webpack_public_path__ + "static/media/xduck.cbecee89.png";